import {
  DashboardStudyRedirectComponent
} from './components/dashboard-study-redirect/dashboard-study-redirect.component';
import {DashboardStudyComponent} from './components/dashboard-study/dashboard-study.component';
import {Routes} from '@angular/router';


export const dashboardStudyRoutes: Routes = [
  {
    // Navigate to this URL if no specific study is selected.
    // It will select the first available study.
    path: 'study',
    component: DashboardStudyRedirectComponent,
  },
  {
    path: 'study/:studyUid',
    component: DashboardStudyComponent,
  },
  {
    path: '**',
    redirectTo: 'study',
    pathMatch: 'full',
  },
];
